import utils from "../utils";
import TextBox from "../core/textbox";
import NumBox from "../core/numbox";
import BoolBox from "../core/boolbox";
import DropDownBox from "../core/dropdownbox";
import CodeBox from "../core/codebox";
import JsonBox from "../core/jsonbox";
import MiniFormBox from '../core/miniformbox'
import DefaultMiniFormBoxMeta from '../core/miniformbox/ui-conf'

const specials = {
    "component_name": {
        component_name: DropDownBox.name,
        name: 'component_name',
        label: 'component_name',
        data_url: "/component/list",
        conf: {
            filterable: true
        }
    },
    "render": {
        component_name: CodeBox.name,
        name: 'render',
        label: 'render',
        height: "250px"
    }
};

function buildMetaByString(key, value) {
    return {
        component_name: TextBox.name,
        name: key,
        label: key,
        value: value,
        inline: false
    }
}

function buildMetaByNumber(key, value) {
    return {
        component_name: NumBox.name,
        name: key,
        label: key,
        value: value,
        inline: false
    }
}

function buildMetaByBoolean(key, value) {
    return {
        component_name: BoolBox.name,
        name: key,
        label: key,
        value: value,
        inline: false
    }
}

function buildMetaByObject(key, value) {
    let defaultMeta;
    let meta = {
        name: key,
        label: key,
        value: value,
        inline: false
    };

    // if (utils.isEmpty(value)) { // 空对象采用JsonBox展示
    //     defaultMeta = DEFAULT.JsonBox;
    //     meta.component_name = JsonBox.name;
    // } else {
    defaultMeta = DefaultMiniFormBoxMeta;
    meta.component_name = MiniFormBox.name;
    meta.columns = [];
    let keys = Object.keys(value);
    for (let i = 0; i < keys.length; i++) {
        meta.columns.push(buildMeta(keys[i], value[keys[i]]));
    }
    // }
    return utils.merge(meta, defaultMeta);
}

function buildMetaByArray(key, value) {
    return {
        component_name: JsonBox.name,
        name: key,
        label: key,
        value: value
    }
}

function buildMeta(key, value) {
    if (utils.hasProp(specials, key)) {
        return specials[key];
    }
    const type = utils.typeOf(value);
    switch (type) {
        case "[object String]":
            return buildMetaByString(key, value);
        case "[object Number]":
            return buildMetaByNumber(key, value);
        case "[object Boolean]":
            return buildMetaByBoolean(key, value);
        case "[object Array]":
            return buildMetaByArray(key, value);
        case "[object Object]":
            return buildMetaByObject(key, value);
        default:
            return buildMetaByString(key, value);
    }
}

/**
 * value在前, 防止只传了value
 * @param value
 * @param key
 * @returns {*|{component_name, name, label, value}}
 */
export default function (value, key) {
    return buildMeta(key, value);
}
